import React, { useRef } from 'react';
import FormGroup from './FormGroup';
import { Controller } from 'react-hook-form';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
export interface FormRichTextProps {
  name?: string;
  control: any;
  label?: string;
  defaultValue?: any;
  placeholder?: string;
  error?: any;
  errorMessage?: string;
  required?: boolean;
  extraRowClasses?: string;
  disabled?: boolean;
  testId?: string;
}

const FormRichText = ({
  label,
  name,
  defaultValue,
  placeholder,
  error,
  errorMessage,
  control,
  required,
  extraRowClasses = 'align-items-start',
  disabled,
  testId,
}: FormRichTextProps) => {
  const quillRef = useRef(null);

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ script: 'sub' }, { script: 'super' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
    ],
  };

  const formats = [
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'script',
    'header',
    'list',
    'size',
    'font',
    'code-block',
  ];

  return (
    <FormGroup
      label={label}
      extraRowClasses={extraRowClasses}
      error={error}
      errorMessage={errorMessage}
      required={required}
    >
      <Controller
        name={name ?? ''}
        control={control}
        defaultValue={defaultValue || ''}
        render={({ field: { onChange, value } }) => (
          <div data-cy={testId}>
            <ReactQuill
              ref={quillRef}
              theme="snow"
              value={value}
              onChange={onChange}
              modules={modules}
              formats={formats}
              placeholder={placeholder}
              readOnly={disabled}
            />
          </div>
        )}
      />
    </FormGroup>
  );
};

export default FormRichText;
